import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Clock, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { BonusesAccordion } from './BonusesAccordion';
export function OfferSection() {
  const features = ['Guía completa (PDF)', 'Plan de 21 días paso a paso', 'Plantillas imprimibles y digitales', 'Rutina AM/PM', 'Vision board por categorías', '3-6-9 + 55x5 (explicados fácil)', 'Acción inspirada diaria'];
  return <section id="oferta" className="py-16 px-4 bg-gradient-to-b from-[#F8F3EA] to-white" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="relative bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-[#D4AF37]" data-id="element-111">
          {/* Top Banner */}
          <div className="bg-[#D4AF37] text-[#2B0A3D] text-center py-3 font-bold tracking-wide uppercase text-sm" data-id="element-112">
            Oferta Especial • Acceso Inmediato
          </div>

          <div className="grid md:grid-cols-2" data-id="element-113">
            {/* Left Side: Value & Price */}
            <div className="p-8 md:p-12 bg-[#2B0A3D] text-white flex flex-col justify-center relative overflow-hidden" data-id="element-114">
              <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-115"></div>

              <div className="relative z-10" data-id="element-116">
                <h2 className="text-3xl font-playfair font-bold mb-2" data-id="element-117">
                  Tu acceso hoy
                </h2>
                <p className="text-white/80 mb-4 text-sm" data-id="element-118">
                  Todo el sistema de 21 días + herramientas listas para usar.
                </p>

                {/* Mockup Image */}
                <img src="https://cdn.magicpatterns.com/uploads/1q2N9Dq5Q7kX8kfPvs53qv/Oferta_-_Mockup.png" alt="Mockup del producto en dispositivos" className="w-full rounded-xl mb-6 shadow-lg" loading="lazy" width="600" height="400" data-id="element-119" />

                <div className="text-center mb-2" data-id="element-120">
                  <span className="text-3xl font-bold text-white/40 line-through" data-id="element-121">
                    $23.91
                  </span>
                </div>

                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-122">
                  <span className="text-6xl font-bold text-[#D4AF37]" data-id="element-123">
                    $7.97
                  </span>
                  <span className="text-xl text-white/60" data-id="element-124">USD</span>
                </div>
                <p className="text-white/60 text-sm mb-8 text-center" data-id="element-125">
                  Pago único • Acceso inmediato • Digital
                </p>

                <div className="space-y-4 pt-6 border-t border-white/10" data-id="element-126">
                  <div className="flex gap-3" data-id="element-127">
                    <Clock className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-128" />
                    <div data-id="element-129">
                      <p className="font-bold text-sm" data-id="element-130">¿Cuándo lo recibo?</p>
                      <p className="text-xs text-white/70" data-id="element-131">
                        Inmediato, es digital.
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3" data-id="element-132">
                    <Clock className="w-5 h-5 text-[#D4AF37] flex-shrink-0" data-id="element-133" />
                    <div data-id="element-134">
                      <p className="font-bold text-sm" data-id="element-135">¿Cuánto tiempo toma?</p>
                      <p className="text-xs text-white/70" data-id="element-136">10–15 min al día.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Features & CTA */}
            <div className="p-8 md:p-12 bg-white flex flex-col justify-center" data-id="element-137">
              <ul className="space-y-4 mb-4" data-id="element-138">
                {features.map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-139">
                    <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-140">
                      <Check className="w-3.5 h-3.5 text-green-600" data-id="element-141" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-142">{feature}</span>
                  </li>)}
              </ul>

              {/* Bonuses Accordion */}
              <BonusesAccordion data-id="element-143" />

              <motion.div animate={{
              scale: [1, 1.05, 1]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="mt-8" data-id="element-144">
                <Button href="https://pay.hotmart.com/X103396152N" variant="primary" size="xl" fullWidth className="mb-4 shadow-xl shadow-[#D4AF37]/20" data-id="element-145">
                  Comprar ahora
                </Button>
              </motion.div>

              <div className="space-y-2 text-center" data-id="element-146">
                <div className="flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-147">
                  <ShieldCheck className="w-3 h-3" data-id="element-148" /> Checkout seguro
                </div>
                <p className="text-xs text-gray-400" data-id="element-149">
                  Acceso inmediato después del pago
                </p>
                <p className="text-xs text-gray-400" data-id="element-150">
                  Funciona vivas donde vivas
                </p>
                <p className="text-xs text-gray-400" data-id="element-151">
                  Resultados varían según tu constancia
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}